import get from 'lodash/get';

const getReasonForEmptyProductGrid = state =>
  get(state, 'search.queryParams.filterTags', []).length > 0
    ? 'Try removing any filters'
    : 'This may be due to store availability';

export default getReasonForEmptyProductGrid;
